"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useReactDomQueryString = void 0;
const qs_1 = require("qs");
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const utils_1 = require("./utils");
const useReactDomQueryString = ({ parseOptions, stringifyOptions, } = {}) => {
    const [searchParams, setSearchParams] = (0, react_router_dom_1.useSearchParams)();
    const query = (0, react_1.useMemo)(() => (0, utils_1.parseSearchParams)(searchParams, parseOptions), [parseOptions, searchParams]);
    const setQuery = (0, react_1.useCallback)((queryOrFunc) => {
        setSearchParams((prevSearchParams) => {
            if (typeof queryOrFunc === 'function') {
                const prevQuery = (0, utils_1.parseSearchParams)(prevSearchParams, parseOptions);
                const newQuery = queryOrFunc(prevQuery);
                return (0, utils_1.stringifyQuery)(newQuery, stringifyOptions);
            }
            return (0, qs_1.stringify)(queryOrFunc, stringifyOptions);
        });
    }, [parseOptions, setSearchParams, stringifyOptions]);
    return [query, setQuery];
};
exports.useReactDomQueryString = useReactDomQueryString;
//# sourceMappingURL=useReactDomQueryString.js.map